'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _plugin = require('../../plugin');
var _plugin2 = _interopRequireDefault(_plugin);
var _messageParser = require('./messageParser');
var _messageParser2 = _interopRequireDefault(_messageParser);
var _messageQueue = require('./messageQueue');
var _messageQueue2 = _interopRequireDefault(_messageQueue);
var _status = require('../status');
var _constants = require('../../constants');
var _lastTimestampHandler = require('../infra/lastTimestampHandler');
var _lastTimestampHandler2 = _interopRequireDefault(_lastTimestampHandler);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function isTypingStanzaSent(stanza) {
  if (stanza.is('message') && stanza.getChildText('thread')) {
    var thread = stanza.getChildText('thread') || '';
    return thread.indexOf('typing') !== -1;
  }
  return false;
}
function isMessage(stanza) {
  return stanza.is('message');
}
function isLoadMessagesResponse(stanza) {
  return stanza.is('iq') && stanza.getChild('fin');
}
var MessageHandler = function (_Plugin) {
  _inherits(MessageHandler, _Plugin);
  function MessageHandler(entity) {
    _classCallCheck(this, MessageHandler);
    var _this = _possibleConstructorReturn(this, (MessageHandler.__proto__ || Object.getPrototypeOf(MessageHandler)).call(this, entity));
    _this.statusHandlers = {
      typing: _this.typingHandler,
      validate_user_profile: _this.profileValidationHandler
    };
    _this.sentMessages = function (stanza) {
      if (isMessage(stanza) && !isTypingStanzaSent(stanza)) {
        _this.handle(_this.messageParser.fromClient(stanza));
      }
    };
    _this.receivedMessages = function (stanza) {
      if (_this.isStatusStanza(stanza)) {
        _this.handleStatus(_this.messageParser.fromWebsocket(stanza));
      } else if (isMessage(stanza)) {
        var message = _this.messageParser.fromWebsocket(stanza);
        _this.saveLastTimestamp(message);
        _this.handle(message);
      } else if (isLoadMessagesResponse(stanza)) {
        _this.flushMessagesFromRoom(stanza);
      }
    };
    _this.saveLastTimestamp = function (_ref) {
      var originalTimestamp = _ref.originalTimestamp;
      _this.lastTimestampHandler.updateFromMicrosecondTimestamp(originalTimestamp);
    };
    _this.entity.on(_constants.Events.SENDING, _this.sentMessages);
    _this.entity.on(_constants.Events.STANZA, _this.receivedMessages);
    return _this;
  }
  _createClass(MessageHandler, [{
    key: 'isStatusStanza',
    value: function isStatusStanza(stanza) {
      var event = stanza.getChild('event');
      if (stanza.is('message') && event) {
        var thread = event.getChild('items').getChild('item').getChild('message').getChildText('thread') || '';
        var statusTypes = Object.keys(this.statusHandlers);
        return statusTypes.some(function (type) {
          return thread.indexOf(type) !== -1;
        });
      }
      return false;
    }
  }, {
    key: 'handleStatus',
    value: function handleStatus(message) {
      var handler = this.statusHandlers[message.customType];
      handler.start(message);
    }
  }, {
    key: 'handle',
    value: function handle(message) {
      var source = message.source;
      if (source !== 'db') {
        this.typingHandler.cancel(message);
        this.entity.emit(_constants.Events.RECEIVED_MESSAGES, [message]);
      } else {
        this.messageQueue.add(message);
      }
    }
  }, {
    key: 'flushMessagesFromRoom',
    value: function flushMessagesFromRoom(stanza) {
      var roomname = stanza.attrs.from;
      var messages = this.messageQueue.flush(roomname);
      if (messages.length > 0) {
        this.entity.emit(_constants.Events.RECEIVED_MESSAGES, messages);
      }
    }
  }]);
  return MessageHandler;
}(_plugin2.default);
MessageHandler.pluginName = 'messageHandler';
MessageHandler.deps = [_messageParser2.default, _messageQueue2.default, _status.TypingHandler, _status.ProfileValidationHandler, _lastTimestampHandler2.default];
exports.default = MessageHandler;